import dynamic from "next/dynamic"
import React from "react"

const LoadingImage = dynamic(
    () => import("components/atoms/Image/LoadingImage"),
    {
        ssr: false,
    }
)

const EventPageSkeleton = () => {
    return (
        <div className="relative mb-14 pt-[70px] md:mb-8">
            {/* Background image */}
            <div className="relative h-[350px] w-full overflow-hidden md:block lg:h-[450px] xl:h-[600px]">
                <div className="flex h-full w-full items-center justify-center bg-gray-300 dark:bg-gray-700">
                    <LoadingImage />
                </div>
            </div>
            <div
                className={`layout flex animate-pulse flex-col-reverse items-start gap-4 py-4 md:flex-row md:gap-20`}>
                <div className="mb-12 flex w-full flex-col gap-8">
                    <div className="hidden gap-10 py-4 md:grid md:grid-cols-3">
                        <div className="h-28 rounded-md bg-gray-200 dark:bg-gray-700"></div>
                        <div className="h-28 rounded-md bg-gray-200 dark:bg-gray-700"></div>
                        <div className="h-28 rounded-md bg-gray-200 dark:bg-gray-700"></div>
                    </div>
                    <div className="order-2 md:order-1">
                        <div className="mb-10 h-7 w-36 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                        <div className="flex flex-col gap-4">
                            <div className="h-3 w-full rounded-full bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-3 w-full rounded-full bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-3 w-full rounded-full bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-3 w-1/3 rounded-full bg-gray-200 dark:bg-gray-700"></div>

                            <div className="flex flex-col gap-4 py-10">
                                <div className="h-3 w-1/2 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                                <div className="h-3 w-1/2 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                                <div className="h-3 w-1/2 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                            </div>
                        </div>
                        <div className="h-3 w-1/3 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                        <div className="grid grid-cols-2 gap-2 py-4 pt-10 md:grid-cols-3 lg:md:grid-cols-4">
                            <div className="h-28 rounded-md bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-28 rounded-md bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-28 rounded-md bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-28 rounded-md bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-28 rounded-md bg-gray-200 dark:bg-gray-700"></div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full flex-col gap-5 rounded-2xl shadow-card dark:shadow-sm md:max-w-[400px] md:p-5">
                    <div className="flex items-center justify-between">
                        <div className="h-5 w-[100px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
                        <div className="h-5 w-[100px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
                    </div>
                    <div className="h-8 w-full rounded-full bg-gray-200 dark:bg-gray-700"></div>
                    <div className="flex items-center gap-2">
                        <svg
                            className="h-14 w-14 text-gray-200 dark:text-gray-700"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                clipRule="evenodd"></path>
                        </svg>
                        <div className="h-5 w-1/2 rounded-full bg-gray-200 dark:bg-gray-700"></div>
                    </div>
                    <div className="flex flex-col items-center gap-4 border-t border-gray-300 pt-5">
                        <div className="flex w-full items-center justify-between">
                            <div className="h-5 w-[100px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
                            <div className="h-5 w-[100px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
                        </div>
                        <div className="h-[156px] w-full rounded-md bg-gray-200 dark:bg-gray-700"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventPageSkeleton
